import { translate, TranslateError } from 'magner';

/**
 * Перевод вне setup компонента: в обработчиках действий таблицы и в .catch запросов.
 * useTranslate() там нельзя — он вызывает useI18n() и бросает исключение.
 * TranslateError переводит через глобальный t Magner (как в features/common/file-request.ts).
 */
export const tGlobal = (code: string): string => new TranslateError(translate(code)).name;

/** ElMessageBox.confirm отклоняется строкой 'cancel' или 'close' — остальное настоящая ошибка */
export const isConfirmCancelled = (e: unknown): boolean => e === 'cancel' || e === 'close';
